module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_InformationCircle1_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM7,3H9V5H7Zm3,10H6V12H7V7H6V6H9v6h1Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_InformationCircle1_16.svg
// module id = 59p/
// module chunks = 1